import React, { Component } from 'react';
import { connect } from 'react-redux';
import { log, post } from '../../util/api';
import {
	Btn,
	IconBtn,
	Card,
	PageHead,
	SearchInput,
	Select,
	Badge,
	Stat,
	Empty,
	Loading,
	Modal,
	Pager,
	DeliveryBar,
	Progress,
	Spinner,
	COLORS,
	notify,
	num,
	pct,
	paginate,
	searchMatch,
	phoneOf,
} from './ui';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import { mockMode, mockLogs, mockDetails, mockUsers, mockTags } from './mockdata';
import moment from 'moment';

class HistoryTable extends Component {
	state = {
		targets: [],
		loading: true,
		eyeLoading: false,
	};
	componentDidMount() {
		this.getLogs();
	}

	// Etiketli birleşik liste görünümü (ayar ya da ?mock=merged)
	isMerged() {
		let { product } = this.props;
		return !!((product && product.settings && product.settings.merged_broadcast_list) || this.mock === 'merged');
	}
	// Geliştirmede ?mock=1 / ?mock=merged: API yerine örnek veri (mockdata.js)
	loadMock() {
		let logData = mockLogs();
		let users = mockUsers();
		let merged = this.mock === 'merged';
		if (merged)
			logData.forEach((it, i) => {
				if (i < 5) it.detail = { ...mockDetails(it.log), selectedTag: it.log.extra.targetlist };
			});
		this.setState({ tagList: mockTags, list: users, filtered_list: users, logData, first_show_array: logData.slice(0, 5), loading: false });
	}
	async getLogs() {
		let { product } = this.props;
		let pid = product.id;
		this.mock = mockMode(this.props.location);
		if (this.mock) return this.loadMock();
		await post('/dahi/tag/list', {}).then((data) => {
			//console.log(data);
			this.setState({ tagList: data.data.result.result });
		});
		await post('/broadcast/listBroadcastUser', { pid, state: 'all' }).then((data) => {
			let list = data.data.result;
			this.setState({
				list,
				filtered_list: list,
				selectedUserId: '',
				loading: false,
				isAddUserModalOpen: false,
				openDeleteModal: false,
				loadingBtn: false,
				openEditModal: false,
				name: '',
				phone: '',
				selectedUser: '',
				selectedUserId: '',
			});
		});
		await log('/live/groupMessageLog/all', { pid }).then((data) => {
			let response = data.data && data.data.message;
			let response_order = _.orderBy(response, ['date'], ['desc']);
			let today = moment();
			let first_five_array = response_order && response_order.length > 4 ? response_order.slice(0, 5) : response_order;
			let same_month_array = _.filter(response_order, (o) => moment(o.date).month() === today.month());
			let first_show_array = same_month_array > first_five_array ? same_month_array : first_five_array;
			this.setState({ logData: _.orderBy(response, ['date'], ['desc']), first_show_array });
		});
		let { first_show_array, tagList, logData } = this.state;
		let merged_broadcast_list = product.settings.merged_broadcast_list;
		if (merged_broadcast_list)
			for (let index = 0; index < first_show_array.length; index++) {
				const element = first_show_array[index];
				let { log, date } = element;
				let groups = [];
				_.map(log.groups, (it) => groups.push(it));
				let new_log = {};
				if (index > 0) {
					new_log = first_show_array && first_show_array[index - 1];
				}
				let tag =
					log && log.extra && log.extra.targetlist
						? _.find(tagList, { _id: log.extra.targetlist }) && _.find(tagList, { _id: log.extra.targetlist }).title
						: log && log.extra && log.extra.targetlist;
				let detail = await this.getDetail(log, groups, date, new_log, tag, true);

				let logData_element = _.findIndex(logData, (o) => o.id === element.id);
				element.detail = detail;
				logData[logData_element].detail = detail;
				this.setState({ first_show_array, logData });
			}
		this.setState({ loading: false });
	}
	closeModal = () => {
		this.setState({ openModal: false, startedSend: false });
	};
	closeModalSent = () => {
		this.setState({ openModalSend: false, startedSend: false });
	};
	exportExcel = async (messageTypes) => {
		this.setState({ buttonLoading: true });
		let { product, t } = this.props;
		let pid = product.id;
		let { details, selected, selectedDate, selectedLog, cancel_trigger_count, total_message_count, messages_from_users, selectedTag } = this.state;
		console.log('selected', selected);
		let sent_list = _.filter(details, { status: 'sent' });
		let delivered_list = _.filter(details, { status: 'delivered' });
		let read_list = _.filter(details, { status: 'read' });
		let error_list = _.filter(details, { status: 'failed' });
		let excel_data = _.map(selected, (o) => {
			let phone_number = /@/.test(o.id) ? o.id.replace(/@.*/, '') : o.id;
			phone_number = ('' + phone_number).replace(/\s+/g, '');

			// Escape special regex characters
			let escapedPhoneNumber = phone_number.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
			let rgx = new RegExp(escapedPhoneNumber);

			let isRead = _.find(read_list, (it) => rgx.test(it.phone_id));
			let isDelivered = isRead || _.find(delivered_list, (it) => rgx.test(it.phone_id));
			let isSent = isDelivered || _.find(sent_list, (it) => rgx.test(it.phone_id));
			let isError = _.find(error_list, (it) => rgx.test(it.phone_id));

			return {
				İsim: o.name,
				Telefon: phone_number,
				'Gönderen Telefon': o.phone,
				Hatalı: '' + !isSent,
				Gönderildi: '' + !!isSent,
				Ulaştı: '' + !!isDelivered,
				Okundu: '' + !!isRead,
			};
		});

		let sheets = [
			{
				name: 'message',
				x: ['Mesaj', 'Tip'],
				datasets: [
					{
						Mesaj: selectedLog.message + (selectedLog.text_message ? ' - ' + selectedLog.text_message : ''),
						Tip: _.find(messageTypes, { value: selectedLog.message_type }).text,
					},
				],
			},
			{
				name: 'message_analytic',
				x: ['İsim', 'Telefon', 'Gönderen Telefon', 'Hatalı', 'Gönderildi', 'Ulaştı', 'Okundu'],
				datasets: excel_data,
			},
		];
		//console.log(selectedLog, excel_data, selected, selectedDate);
		if (this.isMerged()) {
			let data = [
				{
					[t('date')]: moment(selectedDate).format('DD-MM-YYYY HH:mm'),
					[t('message')]: selectedLog.message + (selectedLog.text_message ? ' - ' + selectedLog.text_message : ''),
					message_name: selectedLog.extra && selectedLog.extra.message_name,
					[t('label')]: selectedLog.extra.targetlist,
					[t('total')]: selectedLog.groups.length,
					[t('errored')]: _.filter(excel_data, (it) => it['Hatalı'] === 'true').length,
					[t('sent')]: _.filter(excel_data, (it) => it['Gönderildi'] === 'true').length,
					[t('delivered')]: _.filter(excel_data, (it) => it['Ulaştı'] === 'true').length,
					[t('read_mee')]: _.filter(excel_data, (it) => it['Okundu'] === 'true').length,
					Unsub: cancel_trigger_count,
					Replies: total_message_count,
				},
			];
			let message_data = _.map(messages_from_users, (it) => {
				let phone = it.recipient && it.recipient.replace(/-.*/, '');
				let name = phone && _.find(excel_data, { Telefon: phone });
				return {
					Date: moment(it.sendDate).format('DD-MM-YYYY'),
					Time: moment(it.sendDate).format('HH:mm'),
					Name: (name && name.İsim) || phone,
					Phone: phone,
					Label: selectedTag,
					Message: selectedLog.message + (selectedLog.text_message ? ' - ' + selectedLog.text_message : ''),
					message_name: selectedLog.extra && selectedLog.extra.message_name,
					Reply:
						it &&
						it.message &&
						(it.message.imageUrl ? (it.message.text ? it.message.imageUrl + ' - ' + it.message.text : it.message.imageUrl) : it.message.text),
				};
			});

			sheets = [
				{
					name: 'general_analytic',
					x: [
						t('date'),
						'message_name',
						t('message'),
						t('label'),
						t('total'),
						t('errored'),
						t('sent'),
						t('delivered'),
						t('read_mee'),
						'Unsub',
						'Replies',
					],
					datasets: data,
				},
				{
					name: 'recieve_analytic',
					x: ['Date', 'Time', 'Name', 'Phone', 'Label', 'message_name', 'Message', 'Reply'],
					datasets: message_data,
				},
				{
					name: 'send_analytic',
					x: ['İsim', 'Telefon', 'Gönderen Telefon', 'Hatalı', 'Gönderildi', 'Ulaştı', 'Okundu'],
					datasets: excel_data,
				},
			];
		}
		await fetch('https://log.yapaytech.com/analytic/download', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				filename: moment(selectedDate).format('DD_MM_YYYY_HH_mm_ss') + '_broadcast_message_' + pid,
				sheets,
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let dataurl = data.url;
				var a = document.createElement('a');
				a.href = dataurl;
				a.setAttribute('download', dataurl);
				a.click();
				this.setState({ buttonLoading: false });
			});
	};
	exportRecieve = async (messages) => {
		let { product } = this.props;
		let pid = product.id;
		let messages_from_users = _.flatten(
			_.map(messages, (it) => {
				let message_name = it.log.extra.message_name,
					tag = it.detail.selectedTag,
					message = (it.log.extra.content && it.log.extra.content.text) || it.log.message;

				let messages_from_users = it.detail && it.detail.messages_from_users;
				if (messages_from_users) {
					_.map(messages_from_users, (o) => {
						o.tag = tag;
						o.message_name = message_name;
						o.content_message = message;
					});
					console.log('messages_from_users', messages_from_users);
					return messages_from_users;
				}
			})
		);
		let message_data = _.map(messages_from_users, (it) => {
			let phone = it.recipient && it.recipient.replace(/-.*/, '');
			let name = it.recipientName || phone;
			return {
				Date: moment(it.sendDate).format('DD-MM-YYYY'),
				Time: moment(it.sendDate).format('HH:mm'),
				Name: name || phone,
				Phone: phone,
				Label: it.tag,
				Message: it.content_message,
				message_name: it.message_name,
				Reply:
					it &&
					it.message &&
					(it.message.imageUrl ? (it.message.text ? it.message.imageUrl + ' - ' + it.message.text : it.message.imageUrl) : it.message.text),
			};
		});
		let sheets = [
			{
				name: 'recieve_analytic_all',
				x: ['Date', 'Time', 'Name', 'Phone', 'Label', 'message_name', 'Message', 'Reply'],
				datasets: message_data,
			},
		];
		await fetch('https://log.yapaytech.com/analytic/download', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				filename: 'reply_message_' + pid + '_' + Date.now(),
				sheets,
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let dataurl = data.url;
				var a = document.createElement('a');
				a.href = dataurl;
				a.setAttribute('download', dataurl);
				a.click();
				this.setState({ buttonLoading: false });
			});
	};
	async getDetail(log, groups, date, new_log, tag, noOpenModal = false) {
		let { filtered_list } = this.state;
		this.setState({ btnRefresh: true, eyeLoading: true });
		let { product } = this.props;
		//let pid = product.id;
		if (this.mock) {
			let m = mockDetails(log);
			let res = { details: m.details, detailList: [], cancel_trigger_count: m.cancel_trigger_count, total_message_count: m.total_message_count, messages_from_users: m.messages_from_users };
			this.setState(res);
			if (noOpenModal) return { ...res, selected: groups, selectedLog: log, selectedDate: date, selectedTag: tag, btnRefresh: false, eyeLoading: false };
			return this.setState({ openModal: true, selected: groups, selectedLog: log, selectedDate: date, btnRefresh: false, selectedTag: tag, eyeLoading: false });
		}
		let live_pid = product.settings.live.token;
		let live_id = product.settings.live_id;
		let hash = log && log.extra && log.extra.hash;
		let start_send_time = moment(date).add(log.extra.start_time, 's');
		let _cancel_trigger_count, _total_message_count, _messages_from_users, _details, _detailList;
		await fetch('https://live.dahi.ai/analytics/dialogtab/broadcastResult ', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				template_name: log.template_name || log.message,
				list: 'uid',
				pid: live_pid,
				start_date: moment(start_send_time),
				end_date: moment(start_send_time).add('30', 'd'),
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let list = [];
				_.map(data.data, (it) =>
					_.map(it.list, (o) => {
						o.status = it._id;
						list.push(o);
					})
				);
				_details = list;
				_detailList = data.data;
				this.setState({
					details: list,
					detailList: data.data,
				});
			});
		if (product && product.settings && product.settings.merged_broadcast_list) {
			await fetch('https://live.dahi.ai/analytics/dialogtab/broadcastAfterMessageCount ', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					template_name: log.template_name || log.message,
					hash,
					new_log,
					live_id,
					list: 'uid',
					pid: live_pid,
					cancel_trigger_word: product.settings.cancel_trigger_word,
					start_date: moment(start_send_time).add('-3', 'h'),
					end_date: moment(start_send_time).add('32', 'h'),
				}),
			})
				.then((response) => {
					return response.json();
				})
				.then((data) => {
					let result = data && data.data;
					console.log('rrrr', result);
					if (!result) return;
					let { cancel_trigger_count, total_message_count, messages_from_users } = result;
					if (tag && tag !== 'all') {
						messages_from_users = _.filter(messages_from_users, (it) => {
							let phone = it.recipient.replace(/-.*/, '');
							let user = _.find(filtered_list, (o) => o.phone === phone);
							let user_tag = user && user.data && user.data.tag && _.includes(user.data.tag, tag);
							if (user_tag) return true;
						});
					}
					total_message_count = messages_from_users.length;
					_cancel_trigger_count = cancel_trigger_count;
					_total_message_count = total_message_count;
					_messages_from_users = messages_from_users;
					this.setState({ cancel_trigger_count, total_message_count, messages_from_users });
				});
		}

		/*  */
		if (!noOpenModal) {
			this.setState({ openModal: true, selected: groups, selectedLog: log, selectedDate: date, btnRefresh: false, selectedTag: tag, eyeLoading: false });
		} else {
			return {
				selected: groups,
				selectedLog: log,
				selectedDate: date,
				selectedTag: tag,
				cancel_trigger_count: _cancel_trigger_count,
				total_message_count: _total_message_count,
				messages_from_users: _messages_from_users,
				details: _details,
				detailList: _detailList,
				btnRefresh: false,
				eyeLoading: false,
			};
		}
	}
	async sendMessage() {
		if (this.mock) return this.setState({ startedSend: true, disabledSend: true }); // örnek veride gerçek gönderim yok
		let { selectedLog, targets } = this.state;
		let { product } = this.props;
		let pid = product.id;
		let extra = selectedLog.extra;
		//{id: '120363022784153087@g.us', name: 'Base', phone_id: 13628}
		extra.numbers = _.map(targets, (o) => ({ id: o.id, name: o.name, phone_id: o.number }));
		this.setState({ resending: true });
		await log('/api/addSchedule', {
			category: 'schedule',
			label: 'broadcast_message_event',
			extra,
			pid,
		})
			.then(() => this.setState({ startedSend: true, disabledSend: true, resending: false }))
			.catch(() => {
				this.setState({ resending: false });
				notify(this.props.t('Gönderim oluşturulamadı.'), 'err');
			});
	}
	openDetail(key, ...args) {
		this.setState({ eyeKey: key });
		this.getDetail(...args).catch(() => {
			this.setState({ eyeLoading: false, btnRefresh: false });
			notify(this.props.t('Gönderim sonuçları alınamadı.'), 'err');
		});
	}
	// Kişi bazında durum: telefon numarası sonuç listelerinde aranır (eski ekranla aynı eşleşme).
	personStatus(it, lists) {
		let phone_number = phoneOf(it.id);
		let rgx = new RegExp(phone_number.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
		let isRead = _.find(lists.read, (o) => rgx.test(o.phone_id));
		let isDelivered = isRead || _.find(lists.delivered, (o) => rgx.test(o.phone_id));
		let isSent = isDelivered || _.find(lists.sent, (o) => rgx.test(o.phone_id));
		return { phone_number, isRead, isDelivered, isSent };
	}
	renderFunnel(total, rows) {
		return (
			<div className="wsm-funnel">
				{rows.map((r) => (
					<div key={r.label} className="wsm-funnel-row">
						<div>
							<span style={{ color: r.strong ? COLORS.danger : COLORS.slate, fontWeight: r.strong ? 600 : 400 }}>{r.label}</span>
							<span>
								<strong style={{ color: r.strong ? COLORS.danger : COLORS.navy }}>{num(r.value)}</strong>{' '}
								<span style={{ color: COLORS.muted, fontSize: 12 }}>{pct(r.value, total)}</span>
							</span>
						</div>
						<Progress pct={total ? (r.value / total) * 100 : 0} color={r.color} />
					</div>
				))}
			</div>
		);
	}
	render() {
		let {
			logData,
			loading,
			openModal,
			selected,
			details,
			selectedLog,
			selectedDate,
			btnRefresh,
			targets,
			startedSend,
			disabledSend,
			total_message_count,
			cancel_trigger_count,
			selectedTag,
			filtered_list,
			q,
			typeFilter,
			page = 1,
			personPage = 1,
			eyeKey,
			eyeLoading,
		} = this.state;
		let { t } = this.props;
		if (loading) return <Loading />;
		let merged = this.isMerged();

		let excel_data = _.filter(logData, (it) => it.detail);
		let messageTypes = [
			{ value: 'text', text: t('Yazı') },
			{ value: 'media', text: t('Medya') },
			{ value: 'link', text: t('Link') },
			{ value: 'document', text: t('document') },
			{ value: 'template', text: 'Template' },
			{ value: 'audio', text: t('audio') },
			{ value: 'gif', text: 'Gif' },
			{ value: 'sticker', text: 'Sticker' },
		];
		let typeText = (type) => {
			let ty = _.find(messageTypes, { value: type });
			return (ty && ty.text) || t('Diğer');
		};
		let sent_list = _.uniqBy(
			_.filter(details, (it) => it.status === 'delivered' || it.status === 'read' || it.status === 'sent'),
			'cid'
		);
		let delivered_list = _.uniqBy(
			_.filter(details, (it) => it.status === 'delivered' || it.status === 'read'),
			'cid'
		);
		let read_list = _.filter(details, { status: 'read' });
		let error_listed = _.filter(selected, (it) => {
			let cleanId = phoneOf(it.id);
			let is_sent = sent_list.findIndex((o) => o.phone_id.includes(cleanId));
			if (merged) {
				let is_active = _.findIndex(filtered_list, (o) => o.phone && o.phone.includes(cleanId) && o.state === 'active');
				return is_sent === -1 && is_active >= 0;
			}
			return is_sent === -1;
		});

		// Liste
		let all = _.map(logData, (row, i) => ({ ...row, index: i }));
		let rows = _.filter(all, ({ log }) => {
			if (typeFilter && log.message_type !== typeFilter) return false;
			return searchMatch(q, log.message, log.text_message, log.extra && log.extra.message_name, log.template_name);
		});
		let totalRecipients = _.sumBy(logData, (it) => (it.log && it.log.groups && it.log.groups.length) || 0);
		let thisMonth = _.filter(logData, (it) => moment(it.date).isSame(moment(), 'month')).length;
		let types = _.uniq(_.compact(_.map(logData, (it) => it.log && it.log.message_type)));
		let tagOf = (log) =>
			log && log.extra && log.extra.targetlist
				? _.find(this.state.tagList, { _id: log.extra.targetlist })
					? _.find(this.state.tagList, { _id: log.extra.targetlist }).title
					: log.extra.targetlist
				: '';
		let msgText = (log) => (log.message || '') + (log.text_message ? ' - ' + log.text_message : '');

		// Detay penceresi sayıları
		let sentCount = merged ? (selected || []).length - error_listed.length : sent_list.length;
		let modalTotal = (selected || []).length;
		let lists = { read: read_list, delivered: delivered_list, sent: sent_list };
		let personRows = paginate(selected, personPage, 100);

		return (
			<div>
				<PageHead
					title={t('Gönderim geçmişi')}
					desc={t('Her gönderimin teslimat durumu: gönderildi → ulaştı → okundu. Hatalılara tek tıkla yeniden gönderin.')}
					right={
						<>
							<Btn variant="ghost" icon="refresh" onClick={() => this.setState({ loading: true }, () => this.getLogs())}>
								{t('Yenile')}
							</Btn>
							{merged ? (
								<Btn variant="ghost" icon="download" disabled={!excel_data.length} onClick={() => this.exportRecieve(excel_data)}>
									{t('Yanıtları indir')}
								</Btn>
							) : null}
						</>
					}
				/>
				<div className="wsm-stats">
					<Stat label={t('Toplam gönderim')} value={num((logData || []).length)} sub={`${num(thisMonth)} ${t('bu ay')}`} />
					<Stat label={t('Toplam alıcı')} value={num(totalRecipients)} color={COLORS.primary} />
					<Stat
						label={t('Son gönderim')}
						value={logData && logData[0] ? moment(logData[0].date).format('DD.MM.YYYY') : '—'}
						sub={logData && logData[0] ? moment(logData[0].date).format('HH:mm') : null}
					/>
				</div>
				<Card>
					<div className="wsm-section">
						<div className="wsm-row" style={{ gap: 10 }}>
							<SearchInput value={q} onChange={(v) => this.setState({ q: v, page: 1 })} placeholder={t('Mesaj veya kampanya ara…')} />
							<Select
								auto
								value={typeFilter || ''}
								options={[{ value: '', label: t('Tip') + ': ' + t('Hepsi') }].concat(types.map((ty) => ({ value: ty, label: typeText(ty) })))}
								onChange={(v) => this.setState({ typeFilter: v, page: 1 })}
							/>
						</div>
					</div>
					{!(logData || []).length ? (
						<Empty compact icon="clock" title={t('Henüz gönderim yok')} desc={t('Mesaj Gönder sekmesinden ilk gönderiminizi başlatın.')} />
					) : (
						<>
							<div className="wsm-table-wrap">
								<table className="wsm-table" style={{ minWidth: merged ? 980 : 760 }}>
									<thead>
										<tr>
											<th>{t('message')}</th>
											<th>{t('date')}</th>
											<th>{t('label')}</th>
											{merged ? null : <th>{t('type')}</th>}
											<th className="r">{t('Alıcı')}</th>
											{merged ? <th style={{ width: '22%' }}>{t('Teslimat')}</th> : null}
											{merged ? <th className="r">{t('errored')}</th> : null}
											{merged ? <th className="r">Unsub</th> : null}
											{merged ? <th className="r">{t('Yanıt')}</th> : null}
											<th className="r">{t('Detay')}</th>
										</tr>
									</thead>
									<tbody>
										{paginate(rows, page, 25).map(({ log, date, detail, index }) => {
											let groups = _.map(log.groups, (it) => it);
											let new_log = index > 0 ? logData[index - 1] : {};
											let tag = tagOf(log);
											let key = (log.extra && log.extra.hash) || index;
											let m = null;
											if (merged && detail) {
												let dsent = _.uniqBy(
													_.filter(detail.details, (it) => it.status === 'delivered' || it.status === 'read' || it.status === 'sent'),
													'cid'
												);
												let ddelivered = _.uniqBy(
													_.filter(detail.details, (it) => it.status === 'delivered' || it.status === 'read'),
													'cid'
												);
												let dread = _.filter(detail.details, { status: 'read' });
												let derr = _.filter(log.groups, (it) => {
													let rex = new RegExp(phoneOf(it.id).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
													let is_sent = _.findIndex(dsent, (o) => rex.test(o.phone_id));
													let is_active = _.findIndex(filtered_list, (o) => rex.test(o.phone) && o.state === 'active');
													return is_sent === -1 && is_active >= 0;
												});
												m = {
													total: groups.length,
													failed: derr.length,
													sent: groups.length - derr.length,
													delivered: ddelivered.length,
													read: dread.length,
												};
											}
											return (
												<tr key={index}>
													<td>
														<div className="wsm-ellipsis" style={{ fontWeight: 600 }} title={msgText(log)}>
															{msgText(log) || '—'}
														</div>
														{log.extra && log.extra.message_name ? <div className="wsm-hint">{log.extra.message_name}</div> : null}
													</td>
													<td className="wsm-muted wsm-nowrap">{moment(date).format('DD.MM.YYYY HH:mm')}</td>
													<td className="wsm-muted">{tag || '—'}</td>
													{merged ? null : <td className="wsm-muted">{typeText(log.message_type)}</td>}
													<td className="r">{num(groups.length)}</td>
													{merged ? (
														<td>
															{m ? (
																<>
																	<DeliveryBar total={m.total} sent={m.sent} delivered={m.delivered} read={m.read} failed={m.failed} />
																	<div className="wsm-hint wsm-nowrap" style={{ fontSize: 11, marginTop: 4 }}>
																		{num(m.sent)} {t('sent')} · {num(m.delivered)} {t('delivered')} · {num(m.read)} {t('read_mee')}
																	</div>
																</>
															) : (
																<span className="wsm-faint">—</span>
															)}
														</td>
													) : null}
													{merged ? (
														<td className="r" style={{ color: COLORS.danger, fontWeight: 600 }}>
															{m ? num(m.failed) : '—'}
														</td>
													) : null}
													{merged ? <td className="r">{detail ? num(detail.cancel_trigger_count) : '—'}</td> : null}
													{merged ? <td className="r">{detail ? num(detail.total_message_count) : '—'}</td> : null}
													<td className="r">
														{eyeLoading && eyeKey === key ? (
															<Spinner size={16} />
														) : (
															<IconBtn icon="eye" title={t('Detay')} onClick={() => this.openDetail(key, log, groups, date, new_log, tag)} />
														)}
													</td>
												</tr>
											);
										})}
										{!rows.length ? (
											<tr>
												<td colSpan={merged ? 9 : 6} className="wsm-empty-row">
													{t('Filtrelerle eşleşen kayıt yok.')}
												</td>
											</tr>
										) : null}
									</tbody>
								</table>
							</div>
							{merged ? (
								<div className="wsm-legend">
									{[
										[t('read_mee'), COLORS.bar.read],
										[t('delivered'), COLORS.bar.delivered],
										[t('sent'), COLORS.bar.sent],
										[t('errored'), COLORS.bar.failed],
									].map(([l, c]) => (
										<span key={l}>
											<i style={{ background: c }} />
											{l}
										</span>
									))}
								</div>
							) : null}
							<Pager page={page} pageSize={25} total={rows.length} onChange={(p) => this.setState({ page: p })} label={`${num(rows.length)} ${t('gönderim')}`} />
						</>
					)}
				</Card>

				{selectedLog && openModal ? (
					<Modal
						title={(selectedLog.extra && selectedLog.extra.message_name) || t('Gönderim detayı')}
						desc={
							<>
								{moment(selectedDate).format('DD.MM.YYYY HH:mm')} · {typeText(selectedLog.message_type)}
								{selectedTag ? ' · ' + selectedTag : ''}
								<div className="wsm-ellipsis" style={{ maxWidth: 640 }} title={msgText(selectedLog)}>
									{msgText(selectedLog)}
								</div>
							</>
						}
						icon="chart"
						width={920}
						onClose={() => this.setState({ openModal: false, startedSend: false, personPage: 1 })}
						footLeft={
							<button type="button" className="wsm-btn link" disabled={btnRefresh} onClick={() => this.getDetail(selectedLog, selected, selectedDate, undefined, selectedTag)}>
								{btnRefresh ? t('Yenileniyor…') : t('Sonuçları yenile')}
							</button>
						}
						footer={
							<>
								{error_listed.length && selectedLog.extra ? (
									<Btn variant="outline" icon="refresh" disabled={disabledSend} onClick={() => this.setState({ openModalSend: true, targets: error_listed })}>
										{t('sentToError')} ({num(error_listed.length)})
									</Btn>
								) : null}
								<Btn icon="download" busy={this.state.buttonLoading} onClick={() => this.exportExcel(messageTypes)}>
									{t('DownloadExcel')}
								</Btn>
							</>
						}
					>
						<div className="wsm-stats" style={{ marginBottom: 16 }}>
							<Stat label={t('total')} value={num(modalTotal)} />
							<Stat label={t('sent')} value={num(sentCount)} sub={pct(sentCount, modalTotal)} color={COLORS.primary} />
							<Stat label={t('delivered')} value={num(delivered_list.length)} sub={pct(delivered_list.length, modalTotal)} color="#2E9E6B" />
							<Stat label={t('read_mee')} value={num(read_list.length)} sub={pct(read_list.length, modalTotal)} color={COLORS.info} />
							<Stat label={t('errored')} value={num(error_listed.length)} sub={pct(error_listed.length, modalTotal)} color={COLORS.danger} />
							{merged ? <Stat label="Unsub" value={num(cancel_trigger_count)} color={COLORS.warn} /> : null}
							{merged ? <Stat label={t('Yanıt')} value={num(total_message_count)} color={COLORS.purple} /> : null}
						</div>
						<div className="wsm-grid2" style={{ alignItems: 'start', gridTemplateColumns: 'minmax(0,1fr) minmax(0,1.4fr)' }}>
							<Card pad>
								<div className="wsm-subcard-title" style={{ marginBottom: 12 }}>
									{t('Teslimat hunisi')}
								</div>
								{this.renderFunnel(modalTotal, [
									{ label: t('sent'), value: sentCount, color: COLORS.bar.sent },
									{ label: t('delivered'), value: delivered_list.length, color: COLORS.bar.delivered },
									{ label: t('read_mee'), value: read_list.length, color: COLORS.bar.read },
									{ label: t('errored'), value: error_listed.length, color: '#D9534F', strong: true },
								])}
							</Card>
							<Card>
								<div className="wsm-table-wrap" style={{ maxHeight: 360, overflowY: 'auto' }}>
									<table className="wsm-table">
										<thead>
											<tr>
												<th>{t('name')}</th>
												<th>{t('phone')}</th>
												<th>{t('sentPhone')}</th>
												<th>{t('status')}</th>
											</tr>
										</thead>
										<tbody>
											{_.map(personRows, (it, i) => {
												let ps = this.personStatus(it, lists);
												return (
													<tr key={i}>
														<td>{it.name || it.id}</td>
														<td className="wsm-muted wsm-nowrap">{ps.phone_number}</td>
														<td className="wsm-muted">{it.phone || '—'}</td>
														<td>
															{ps.isRead ? (
																<Badge tone="info">{t('read_mee')}</Badge>
															) : ps.isDelivered ? (
																<Badge tone="ok">{t('delivered')}</Badge>
															) : ps.isSent ? (
																<Badge>{t('sent')}</Badge>
															) : (
																<Badge tone="danger">{t('errored')}</Badge>
															)}
														</td>
													</tr>
												);
											})}
										</tbody>
									</table>
								</div>
								<Pager
									page={personPage}
									pageSize={100}
									total={(selected || []).length}
									onChange={(p) => this.setState({ personPage: p })}
									label={`${num((selected || []).length)} ${t('kişi')}`}
								/>
							</Card>
						</div>
					</Modal>
				) : null}

				{this.state.openModalSend ? (
					<Modal
						title={`${t('sentToError')} (${num(targets.length)})`}
						desc={startedSend ? null : t('sendErrorGroupsSure')}
						icon="refresh"
						width={620}
						busy={this.state.resending}
						onClose={this.closeModalSent}
						bodyStyle={startedSend ? undefined : { padding: 0 }}
						footer={
							startedSend ? (
								<Btn onClick={this.closeModalSent}>{t('Tamam')}</Btn>
							) : (
								<>
									<Btn variant="ghost" onClick={this.closeModalSent} disabled={this.state.resending}>
										{t('no')}
									</Btn>
									<Btn icon="send" busy={this.state.resending} onClick={() => this.sendMessage(false)}>
										{t('yes')}
									</Btn>
								</>
							)
						}
					>
						{startedSend ? (
							<div style={{ fontSize: 14 }}>{t('statedErrorNumbers')}</div>
						) : (
							<div style={{ maxHeight: 320, overflowY: 'auto' }}>
								<table className="wsm-table">
									<tbody>
										{_.map(targets, (it, i) => (
											<tr key={i}>
												<td>{it.name || it.id}</td>
												<td className="wsm-muted">{phoneOf(it.id)}</td>
												<td className="wsm-muted">{it.phone === 'waba' || it.type === 'chat' || /@c\.us/.test(it.id) ? t('Kişi') : t('Grup')}</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						)}
					</Modal>
				) : null}
			</div>
		);
	}
}

const stateToProps = (state) => ({
	access: state.access,
	location: state.router.location,
	product: state.product.live,
	user: state.access.user.loggedUserObj,
});
export default connect(stateToProps)(withTranslation()(HistoryTable));
